module.exports = __webpack_public_path__ + "static/small-worlds-1ee1b21d48a47bd3a589be0040c00e23.jpg";